<template>
  <div class="add-info">
      <van-overlay :show="infoShow" :lock-scroll="true">
         <div class="add_info_wrapper" >
            <div class="add_info_wrapper_title">{{title}}</div>
            <div class="add_info_wrapper_input" v-click-outside="onClick">
               <input type="text" v-model.trim="custom" class="add_info_wrapper_input_custom" placeholder="请输入" @input="querySearch">
               <div class="add_info_wrapper_input_dropdown" v-if="dropdownShow" >
                  <div class="scroll-height" ref="scroll">
                     <van-list 
                     v-model="loading"
                     :finished="finished"
                     finished-text="没有更多了"
                     @load="onLoad"
                     >
                        <van-cell v-for="(item,index) in list" :class="{'active':choiceCode == item.code}" :key="item.id+index" @click="choiceTag(item)">{{item.name}}</van-cell>
                     </van-list>
                  </div>
                  
               </div>
            </div>
            <div class="add_info_wrapper_btn" @click="confirm">确认</div>
            <i class="icon_del" @click="close"></i>
         </div>
     </van-overlay>
  </div>
</template>

<script>
import {_getPage} from '../../api/children-file';
import BScroll from "better-scroll";
export default {
   name:"add-info",
   props:{
      // 是否展示
      infoShow:{
         type:Boolean
      },
      // 标题
      title:{
         type:String,
      },
      // 1:爱好;2:标签
      type:{
         type:String, 
      },
      // 编码
      code:{
         type:String,
      },
   },
   data() {
      return{
         custom:"", // 自定义内容
         dropdownShow:false, // 默认不展示下拉列表
         currentPage:1, // 当前页码
         pageSize:5, // 每页条数
         loading:false,
         finished:false, // 是否加载完成
         list:[],
         bs:null, // 滚动条插件
         choiceCode:"",//选中标签的code
      }
   },
   watch:{
   },
   created() {
   },
   mounted(){
   },
   methods:{
      // 初始化滚动插件
      initSroll() {
         if(!this.$refs.scroll){
            return;
         }
         this.bs = new BScroll(this.$refs.scroll,{
            pullUpLoad: true,
            scrollbar: false,
            pullDownRefresh: true,
            scrollX:true,
            scrollY:true,
            bounce:false,
            bindToTarget:true,
            click:true,
            quadrant:2, // 父元素或者祖先元素旋转的角度为 (45, 135]，quadrant 建议为 2，尤其是 90 度，quadrant 必须为 2
            stopPropagation:true // 内部滑动禁止外补滑动
         })
      },
      // 查询标签或者爱好的数据
      queryPage(currentPage,labelContentName) {
         let params = {
            asc:false,
            currentPage:currentPage,
            pageSize:this.pageSize,
            orderByField:'',
            queryData:{
               labelContentName:labelContentName, // 模糊查询值
               labelId:'',
               labelCode:this.type == 1 ? this.code : 'childrenlabel'
            },
         }
         this.loading = true;
         _getPage(params).then(res=>{
            this.loading = false;
            if(res.code == 200){
               if(currentPage == 1){
                  this.list = res.data.records;
               }else{
                  this.list =this.list.concat(res.data.records);
               }
               if(this.list.length > 0){
                  this.dropdownShow = true;
                  // 等DOM渲染后再加载滚动效果，需要延迟加载
                     setTimeout(()=>{
                        this.initSroll()
                     },200)
               }else{
                  this.dropdownShow = false;
               }
               if(this.list.length >= res.data.total){
                  this.finished = true;
               }else{
                  this.currentPage+=1;
                  this.onLoad()
               }
               
            }
         })
      },
      // 下拉列表加载数据
      onLoad() {
         this.queryPage(this.currentPage,this.custom);
      },
      // 搜索
      querySearch() {
         setTimeout(()=>{
            this.currentPage = 1;
            this.queryPage(this.currentPage,this.custom);
         },200)
      },
      // 选中自定义标签或爱好
      choiceTag(item) {
         this.custom = item.name;
         this.choiceCode = item.code;
         setTimeout(()=>{
            this.dropdownShow = false;
         },20)
      },
      // 关闭弹窗
      close() {
         this.$emit('close');
         setTimeout(()=>{
            this.custom = "";
         },200)
      },
      // 确认
      confirm() {
         if(this.custom.length == 0){
            Toast({message:'请输入标签名称',className:'rotation'});
            return;
         }
         if(this.custom.length > 10){
            Toast({message:'请输入十个字以内的标签名称',className:'rotation'});
            return;
         }
         this.$emit('confirm',this.custom);
         setTimeout(()=>{
            this.custom = "";
         },200)
      },
      // 除下拉框区域之外的点击
      onClick() {
         this.dropdownShow = false;
      },
   }
}
</script>

<style lang="scss" scoped>
.van-overlay {
    display: flex;
    justify-content: center;
    align-items: center;
    z-index:9999;
    .add_info_wrapper{
       width:315px;
       height:177px;
       border-radius:16px;
       background:#fff;
       position: relative;
       .add_info_wrapper_title{
          width:100%;
          margin-top:30px;
          text-align: center;
          color:#666;
          font-size:14px;
          font-weight:400;
          font-family: PingFangSC-Regular, PingFang SC;
       }
       .add_info_wrapper_input{
          margin-top:18px;
          text-align: center;
          position:relative;
          .add_info_wrapper_input_custom{
             width:155px;
             height:32px;
             border-radius:8px;
             border:1px solid #ccc;
             padding:6px 10px;
             color:#666;
             font-size:14px;
             
          }
          .add_info_wrapper_input_dropdown{
             width:110px;
             height:155px;
             border-radius:8px;
             background:#fff;
             box-shadow:0px 2px 4px 0px rgba(201,201,201,0.5);
             position: absolute;
             top:34px;
             left:50%;
             margin-left:-77px;
             z-index:101;
             
             .scroll-height{
                overflow: hidden;
                height:100%;
             }
             .van-list{
                text-align: left;
               //  height:100%;
               height:auto;
               padding:3px 0;
               overflow-y: auto;
               padding:3px 0;
             }
             .van-cell{
                padding:3px 8px;
                line-height:21px;
                background: transparent;
                &::after{
                   border-color:transparent;
                }
                &:not(:last-child){
                    margin-bottom:3px;
                }
                color:#666;
                &.active{
                   .van-cell__value--alone{
                      color:#fff;
                   }
                   
                   background: #ff8340;
                }
             }
          }
          
       }
       .add_info_wrapper_btn{
          width:100%;
          height:50px;
          background: #F2F2F2;
          border-bottom-left-radius:16px;
          border-bottom-right-radius:16px;
          margin-top:27px;
          text-align: center;
          line-height:50px;
          color:#666;
          position: absolute;
          bottom:0;
          z-index:100;
          &:hover{
             color:#fff;
             background: #ff8340;
          }
       }
       .icon_del{
          display: block;
          width:12px;
          height:12px;
          background: url('../../assets/images/children-file/close.png') no-repeat;
          background-size:100% 100%;
          position: absolute;
          right:15px;
          top:15px;
          cursor: pointer;
       }
    }
}
</style>